export default __webpack_public_path__ + "static/process_-f54133dcb475715a0945ee29f8e44c8e.png";